const tracking = require('../../modules/utils/tracking.utils');
const insuranceCatalogueCollection = require('../../modules/collections/insurance_catalogue.collection').getInstance();
const priceManagerCollection = require('../../modules/collections/pricemanager.collection').getInstance();
const isProductFiltered = require('./ancillaries_module.collection.product.filtering');

let _childViews;

module.exports = function(childViews) {
    _childViews = childViews;

    return Odigeo.CollectionView.extend({

        afterBindCollection: function() {
            this.listenTo(this.collection, 'add', this.onAncillaryAddedToCollection);
            this.listenTo(this.collection, 'remove', this.destroyChildren);
            return this;
        },

        destroyChildView: function(model) {
            const index = this.collection.indexOf(model);
            this.destroyChildren(model, this.collection, {index: index});
            if (this._childViews[index]) {
                this._childViews[index].$el.remove();
            }
        },

        onAncillaryAddedToCollection(model) {
            const products = model.get('products');
            const isCompound = products && products.length > 1;
            const filteredProducts = (products || []).filter(({policy}) => !isProductFiltered(policy));
            const shouldRender = this.shouldRender({
                filteredProducts,
                isCompound,
                identifier: model.get('productIdentifier'),
            });

            if (shouldRender) {
                this.filterInnerProducts({model, isCompound, filteredProducts});
                this.renderChild(model);
            } else {
                this.destroyChildView(model);
            }
        },

        filterInnerProducts({model, isCompound, filteredProducts}) {
            if (isCompound) {
                model.set('products', filteredProducts);
            }
        },

        shouldRender({filteredProducts, isCompound, identifier}) {
            return isCompound
                ? this.shouldRenderCompoundProduct(filteredProducts)
                : !isProductFiltered(identifier);
        },

        shouldRenderCompoundProduct(filteredProducts) {
            return filteredProducts.length > 0;
        },

        renderChild(model) {
            const viewClass = model.getViewClass();
            const defaultTemplate = Odigeo.View.extend({tagName: 'div'});
            const childView = Odigeo._.get(_childViews, viewClass, defaultTemplate);
            const childViewOptions = {
                widget: this.widget,
                options: this.widget.options,
                model: model,
            };

            this.destroyChildView(model);

            if (!model.isMultiOfferWithOnlyMandatory()) {
                this.addChildView(childView, childViewOptions, model);
                Odigeo.trigger(this.widget.name + ':ancillaryProductRendered', model);
                model.registerOffersForTracking();
            }

            if (Odigeo._.last(this.collection.models) === model) {
                tracking.stopMetric(this.widget.getLoadMetricKey());
            }
        },

        isPreselectedInsurance: function(model) {
            const modelID = model.get('id');
            const policy = model.get('policy');
            const insurance = insuranceCatalogueCollection.getInsurance(modelID);
            return policy === 'CANXSELF' ?
                this.isCANXSELFSelectedInPax() :
                Odigeo._.get(insurance, 'preselected', false);
        },

        isPreselectedCanxSelf: function(model) {
            const policy = model.get('policy');
            return policy === 'CANXSELF' ? this.isCANXSELFSelectedInPax() : false;
        },

        isCANXSELFSelectedInPax: function() {
            const priceManagerCollectionData = priceManagerCollection.getJSONData();
            const fareUpgradeC4ar = Odigeo._.find(priceManagerCollectionData.items, {'conceptKey': 'CANXSELF'});
            return !Odigeo._.isUndefined(fareUpgradeC4ar) &&
                insuranceCatalogueCollection.isRefundableFareUpgradeSetInPax() &&
                insuranceCatalogueCollection.isRefundableFareUpgradeShowInPax();
        },
    });
};
